<div class=" !w-screen h-screen custom-scroll flex place-content-center absolute top-0 left-0 z-[2]"
    *transloco="let t;prefix:'auth'">
    <div class="">
        <div class="absolute hidden aspect43:flex left-[60px] top-[166px] cursor-pointer" (click)="backToLogin()"><svg width="42" height="38" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M41.5 20.5723L5.03223 20.5723L18.3965 34.0654L18.7158 34.3877L18.4268 34.7373L17.1113 36.3193L16.7588 36.7441L16.3711 36.3516L0.64453 20.4238L0.499999 20.2773L0.499999 17.7227L0.644531 17.5762L16.3711 1.64844L16.7266 1.28906L17.082 1.64844L18.498 3.07715L18.8457 3.42871L18.499 3.78027L5.02832 17.4277L41.5 17.4277L41.5 20.5723Z" fill="#1F299C" stroke="#1F299C"/>
</svg>
</div>
        <div title class="text-font63px text-center text-quaternary mt-[163px] mb-[54px]">
            Registrati
        </div>

        <div class="flex flex-wrap max-w-[900px] gap-[100px] gap-y-[25px] place-content-center">
            <div class="w-[350px]">
                <std-input labelPosition="top" customInputClass="custom-input !w-[350px]"
                    customLabel="label-input" [label]="'Nome'" [placeholder]="'Inserisci nome'"
                    customContainerlass="mb-8" [(ngModel)]="credentials.firstName" [value]="credentials.firstName"
                    id="firstName-login" type="firstName">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input !w-[350px]" customLabel="label-input"
                    [label]="'Cognome'" [placeholder]="'Inserisci cognome'" customContainerlass="mb-8"
                    [(ngModel)]="credentials.lastName" [value]="credentials.lastName" id="email-lastName"
                    type="lastname">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input !w-[350px]" customLabel="label-input"
                    [label]="'Email'" [placeholder]="'Inserisci email'" customContainerlass="mb-8"
                    [(ngModel)]="credentials.email" [value]="credentials.email" id="email-login" type="email">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input !w-[350px]" customLabel="label-input"
                    [label]="'Telefono'" [placeholder]="'Inserisci telefono'" customContainerlass="mb-8"
                    [(ngModel)]="credentials.phone" [value]="credentials.phone" id="phone-login" type="phone">
                </std-input>
            </div>
            <div class="w-[350px]">
                <std-input labelPosition="top" customInputClass="custom-input !w-[350px]" customLabel="label-input"
                    [label]="'Password'" [placeholder]="'Inserisci password'" [(ngModel)]="credentials.password"
                    id="password-login" [type]="showPassword ? 'text':'password'" [value]="credentials.password">
                </std-input>

                <div class="text-quaternary text-12 mt-5">{{checkPassword(credentials?.password ?? '')}}</div>

                <std-input labelPosition="top" customInputClass="custom-input !w-[350px]" customLabel="label-input mt-8"
                    [label]="'Ripeti password'" [placeholder]="'Ripeti password'" [(ngModel)]="credentials.confirmPassword"
                    id="confirm-password-login" [type]="showPassword ? 'text':'password'" [value]="credentials.confirmPassword">
                </std-input>
            </div>

        </div>
        <div class="flex text-font18px flex-wrap gap-[50px] text-quaternary mt-10 mx-auto w-[350px] aspect43:w-auto">
            <div class="flex gap-2.5 items-center">
                <std-checkbox (onChange)="checkboxTerms($event)" [isChecked]="acceptTerms" height="23px" width="23px" backGroundTrue="#1F299C"
                    borderTrue="#1F299C"></std-checkbox>
                <div class="opacity-50">Accetto <a href="../../assets/Condizioni_Generali_di_Contratto-DEF..pdf?v=1.0" target="_blank" class="underline cursor-pointer">Termini & Condizioni</a></div>

            </div>
            <div class="flex gap-2.5 items-center">
                <std-checkbox (onChange)="checkboxprivacy($event)" [isChecked]="acceptPrivacy" height="23px" width="23px" backGroundTrue="#1F299C"
                    borderTrue="#1F299C"></std-checkbox>
                <div class="opacity-50">Accetto <a href="../../assets/INFORMATIVA PRIVACY_DEF.pdf" target="_blank" class="underline cursor-pointer">Privacy & Policy</a></div>
            </div>
        </div>
        <div class="ml-auto w-full mt-[100px]">
            <std-button (click)="register()" id="button-login" size="sm"
                buttonClass="bg-quaternary rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Registrati</std-button>

        </div>


    </div>
</div>